import React from 'react';
import styles from './button.module.scss';
import classname from 'classname';
import { prop } from 'lodash/fp';

const variantToClassMap = {
  primary: 'primary',
  plain: 'plain',
  dangerplain: 'dangerplain',
  danger: 'danger',
  gray: 'gray',
};

const Button = (props) => {
  return (
    <button
      {...props}
      disabled={props.isDisabled ? props.isDisabled : props.loading}
      className={classname(
        props.isDisabled ? styles.isDisabled : styles.button,
        props.small ? styles.small : '',
        styles[variantToClassMap[props.variant]],
        props.className,
      )}
      style={props.style}
      {...props.rest}
    >
      <span className={styles.text}>
        {props.loading ? props.loadingtext : props.text}
      </span>
      <span className={styles.icon}>{props.icon && props.icon}</span>
    </button>
  );
};

export default Button;
